import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ books, onConfirm, onClose, isDeleting }) => {
  const count = books?.length || 0;
  const isBulk = count > 1;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card rounded-xl shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center shrink-0">
              <Icon name="Trash2" size={24} className="text-error" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">
                {isBulk ? `Delete ${count} Books` : 'Delete Book'}
              </h2>
              <p className="text-sm text-muted-foreground mt-0.5">
                This action cannot be undone.
              </p>
            </div>
          </div>

          {isBulk ? (
            <p className="text-sm text-foreground mb-4">
              Are you sure you want to delete <strong>{count} selected books</strong> from the catalog?
            </p>
          ) : (
            <p className="text-sm text-foreground mb-4">
              Are you sure you want to delete <strong>&ldquo;{books?.[0]?.title}&rdquo;</strong> from the catalog?
            </p>
          )}

          <div className="flex items-center justify-end gap-3">
            <Button variant="outline" onClick={onClose} disabled={isDeleting}>Cancel</Button>
            <Button
              onClick={onConfirm}
              disabled={isDeleting}
              className="bg-error hover:bg-error/90 text-white border-error"
            >
              {isDeleting ? (
                <span className="flex items-center gap-2">
                  <Icon name="Loader2" size={16} className="animate-spin" />
                  Deleting...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <Icon name="Trash2" size={16} />
                  {isBulk ? `Delete ${count} Books` : 'Delete Book'}
                </span>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
